import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class GetDemo extends Component {
    render() {
        return (
            <div className="container py-7">
                <div className="bg-primary py-7 rounded-lg">
                    <div className="container-sm">
                        <div className="text-center">
                            <h2 className="text-white">Ready to move your business to the modern age?</h2>
                            <Link className="btn btn-white mr-4 mt-4" to="/demo">Request a demo</Link>
                            <Link className="btn btn-outline-white mt-4" to="/contact">Contact sales</Link>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default GetDemo;